import { redirect, useLoaderData } from 'react-router'
import type { LoaderFunctionArgs } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { PageHeading } from '@/components/subscription/page-heading'
import { TextLink } from '@/components/subscription/text-link'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import * as styles from './styles.css'

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url)
  const productId = url.searchParams.get('product_id')

  if (!productId) {
    return redirect('/subscription/mypage/bulk')
  }

  const subscriptions = await fetchSubscriptions()
  const subscription = subscriptions.data.data[0]

  if (!subscription) {
    return redirect('/subscription/mypage')
  }

  const product = await fetchProduct(subscription.id)
  const inBulkProduct = product?.data?.included?.find((item: any) => item.type === 'flower_collection_product' && item.id === productId)

  if (!inBulkProduct) {
    return redirect('/subscription/mypage/bulk')
  }

  return inBulkProduct
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions()
}

function fetchProduct(id: string) {
  return createClient(Subscriptions).getSubscriptionsSubscriptionIdProduct(id)
}

export const SubscriptionMypageBulkDone: React.FC = () => {
  const product = useLoaderData<typeof loader>()

  const price = Intl.NumberFormat('ja-JP').format(product.attributes.bulk_discounted_price)

  return (
    <Flex direction="column" align="center" gap="80px">
      <Flex direction="column" align="center" gap="24px">
        <h1 className={styles.heading}>
          グッズのご注文
          <br />
          ありがとうございました！
        </h1>
        <Flex direction="column" align="center" gap="8px">
          <img src={product.attributes.image_small_url} alt={product.attributes.name} className={styles.productImage} />
          <p className={styles.productName}>{product.attributes.name}</p>
          <p className={styles.price}>{price}円</p>
        </Flex>
        <p className={styles.note}>グッズの代金は、次回の決済時にブーケ代金と合わせて請求されます。</p>
      </Flex>
      <TextLink to="/subscription/mypage">マイページに戻る</TextLink>
    </Flex>
  )
}
